import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import React from "react";

interface QuestionSectionHeaderProps {
  activeQuestionIndex: number;
  currentSessionQuestions: string[];
  handleNext: () => void;
  handleBack: () => void;
}

const QuestionSectionHeader: React.FC<QuestionSectionHeaderProps> = ({
  activeQuestionIndex,
  currentSessionQuestions,
  handleNext,
  handleBack,
}) => {
  return (
    <div className="question-section-header">
      <div>
        <span
          className="navigate-icon"
          onClick={handleBack}
          style={{
            opacity: activeQuestionIndex > 0 ? 1 : 0.5,
            marginRight: "10px",
            fontWeight: activeQuestionIndex > 0 ? "bold" : "normal",
            color: activeQuestionIndex > 0 ? "black" : "inherit",
            cursor: activeQuestionIndex > 0 ? "pointer" : "not-allowed",
          }}
        >
          <LeftOutlined />
        </span>
        Questions: {activeQuestionIndex + 1}/{currentSessionQuestions.length}
        <span
          className="navigate-icon"
          onClick={handleNext}
          style={{
            opacity:
              activeQuestionIndex < currentSessionQuestions.length ? 1 : 0.5,
            marginLeft: "10px",
            fontWeight:
              activeQuestionIndex < currentSessionQuestions.length
                ? "bold"
                : "normal",
            color:
              activeQuestionIndex < currentSessionQuestions.length
                ? "black"
                : "inherit",
            cursor:
              activeQuestionIndex < currentSessionQuestions.length
                ? "pointer"
                : "not-allowed",
          }}
        >
          <RightOutlined />
        </span>
      </div>
    </div>
  );
};

export default QuestionSectionHeader;
